import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";
import { keys } from "./keys";

type Command = Database['public']['Tables']['provider_contacts']['Update'];

async function putProviderContact(contactId: string, command: Command) {
  const { data, error } = await apiClient
    .from('provider_contacts')
    .update(command)
    .eq('id', contactId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export default function usePutProviderContact(providerId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { contactId: string; command: Command }) => putProviderContact(variables.contactId, variables.command),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getProviderContacts(providerId) });
    },
  });
}
